import { Component,Input,ViewChild } from '@angular/core';
import { DynamicFlow_Column,ChartCommonDataColors,ChartDataColors } from '@app/models/dashboard/dynamicDashboard';
import { BaseChartDirective } from 'ng2-charts/ng2-charts';


@Component({
  selector: 'chart-control',
  templateUrl: './chart.component.html'
})
export class DynamicChartComponent {
 

 constructor(){ 
 }
 
  @ViewChild("baseChart") chart: BaseChartDirective; 
  @Input() dynamicFlow_Column: DynamicFlow_Column;  
 
 ngAfterViewInit() {      
    if (this.dynamicFlow_Column && this.chart) {   
        this.reloadChart();
    }
}

reloadChart() {
        if (this.chart !== undefined && (!!this.dynamicFlow_Column)) {
           this.chart.ngOnDestroy();           
           this.chart.chartType = this.dynamicFlow_Column.Chart_Type;
           this.chart.datasets = this.dynamicFlow_Column.DataColumns_DataSet;
           this.chart.labels = this.dynamicFlow_Column.DataColumns_Heading;
           this.chart.options = this.dynamicFlow_Column.Chart_Options;  
           if(this.chart.chartType != null && (!this.chart.chartType.toLowerCase().startsWith('line')))
           {
            let currentColorSet: Array<ChartCommonDataColors> = this.AssignChartCommonColorCodeArray();
           
            if(currentColorSet != null && currentColorSet.length > 0)
            {
              this.chart.colors = currentColorSet;           
            }
            else
            {
              this.chart.colors = this.dynamicFlow_Column.DataColumns_Color;
            }
          }
          else
          {
            
            let currentColorSet: Array<ChartDataColors> = this.AssignChartCommonColorCode();
           
            if(currentColorSet != null && currentColorSet.length > 0)
            {
              this.chart.colors = currentColorSet;           
            }
            else
            {
              this.chart.colors = this.dynamicFlow_Column.DataColumns_Color;
            }
          }
           if(this.dynamicFlow_Column.Chart_Type !="radar"
            && this.dynamicFlow_Column.Chart_Type !="doughnut"
            && this.dynamicFlow_Column.Chart_Type !="pie"  )
           {
            
            this.chart.options = {
              legend:{
                display: false
              },
              scales: {
                xAxes: [{
                  display: true,
                  scaleLabel: {
                    display: true,
                    labelString: this.dynamicFlow_Column.XHeading
                  }
                }],
                yAxes: [{
                  display: true,
                  scaleLabel: {
                    display: true,
                    labelString: this.dynamicFlow_Column.YHeading
                  },
                  ticks: {
                    beginAtZero: true,
                    steps:10
                    
                  }
                }]
              },
              responsive: true
            };
          }
          else
          {
            this.chart.options = {
              legend:{
                display: true,
                position:"bottom"
              },              
              responsive: true
            };
          }
           this.chart.ngOnInit();
          // console.log(this.dynamicFlow_Column.Chart_Type);
        }
   }
  
  onChartClick(event) {
    console.log(event);
  }
   
  AssignChartCommonColorCodeArray()
  {
    let appliedChartColors : Array<ChartCommonDataColors> = new Array<ChartCommonDataColors>();
  
    appliedChartColors.push(this.ChartDataColorsCommonArray());
   
    return appliedChartColors;
  }
  AssignChartCommonColorCode()
  {
    let appliedChartColors : Array<ChartDataColors> = new Array<ChartDataColors>();
  
    appliedChartColors.push(this.ChartDataColorsCommon(70,130,180));
    appliedChartColors.push(this.ChartDataColorsCommon(219,112,147));
    
    appliedChartColors.push(this.ChartDataColorsCommon(255,165,0));
    appliedChartColors.push(this.ChartDataColorsCommon(219,112,147));
    appliedChartColors.push(this.ChartDataColorsCommon(105,105,105));
    appliedChartColors.push(this.ChartDataColorsCommon(70,130,80));
    appliedChartColors.push(this.ChartDataColorsCommon(139,0,0));
    appliedChartColors.push(this.ChartDataColorsCommon(210,105,30));
    appliedChartColors.push(this.ChartDataColorsCommon(70,0,130));
    

   
    return appliedChartColors;
  }
  
  
  ChartDataColorsCommonArray()
        {
           let color:ChartCommonDataColors = new ChartCommonDataColors();
           color.backgroundColor = ['SteelBlue','SeaGreen','Peru','OrangeRed','DarkCyan','Brown','DarkSlateGray	','DarkGreen','Teal','DarkGoldenrod','HotPink'];  //light color
           color.hoverBackgroundColor = ['SteelBlue','SeaGreen','Peru','OrangeRed','DarkCyan','Brown','DarkSlateGray	','DarkGreen','Teal','DarkGoldenrod','HotPink']; //dark color
           color.pointBackgroundColor = ['SteelBlue','SeaGreen','Peru','OrangeRed','DarkCyan','Brown','DarkSlateGray	','DarkGreen','Teal','DarkGoldenrod','HotPink']; //extra dark color
           color.borderColor = ['SteelBlue','SeaGreen','Peru','OrangeRed','DarkCyan','Brown','DarkSlateGray	','DarkGreen','Teal','DarkGoldenrod','HotPink']; //extra extra dark color
        
           color.pointBorderColor = "#fff";
           color.pointHoverBackgroundColor = "#fff";
           color.pointHoverBorderColor = ['SteelBlue','SeaGreen','Peru','OrangeRed','DarkCyan','Brown','DarkSlateGray	','DarkGreen','Teal','DarkGoldenrod','HotPink'];
           return color;
        }
        ChartDataColorsCommon(r:number,g:number,b:number)
        {
           let color:ChartDataColors = new ChartDataColors();         
        
           color. backgroundColor = "rgba(" + r.toString() + "," + g.toString() + "," + b.toString() + ",.7)";
           color. hoverBackgroundColor = "rgba(" + r.toString() + "," + g.toString() + "," + b.toString() + ")";
           color. pointBackgroundColor = "rgba(" + r.toString() + "," + g.toString() + "," + b.toString() + ")";
           color. borderColor = "rgba(" + r.toString() + "," + g.toString() + "," + b.toString() + ")";
           color. pointBorderColor = "#fff";
           color. pointHoverBackgroundColor = "#fff";
           color. pointHoverBorderColor = "rgba(" + r.toString() + "," + g.toString() + "," + b.toString() + ",.9)";
           return color;
        }
        
}


// WEBPACK FOOTER //
// ./src/app/components/common/chart.component.ts